import { useSelector } from "react-redux"
import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"

import Banner from "@/component/banner"
import BannerForm from "@/component/form/bannerForm"
import Environment from "@/pages/home/components/environment"
import Campus from "@/pages/home/components/campus"

function Index() {
  const classnames = classModuleGenerator(styles)
  const { photos } = useSelector((state) => state.page)
  const banners = [
    {
      imageUrl: require("@/assets/images/fudu-banner.jpg"),
      intro: "给我一年时间，还您一个奇迹！",
      name: "学大全日制复读班",
      _id: "fudu",
    },
  ]
  const teacers = [
    {
      name: "执教中多为考核",
      intro: "教师历经严格筛选多层考核",
    },
    {
      name: "培训考核",
      intro: "熟知新课标新课改教育政策",
    },
    {
      name: "试讲考核",
      intro: "多年艺考带班教学经验丰富",
    },
    {
      name: "面试考核",
      intro: "师资团队深受学生欢迎更懂学生",
    },
    {
      name: "笔试考核",
      intro: "实时同步集团全国艺考教研教学体系",
    },
    {
      name: "资质审核",
      intro: "",
    },
  ]

  return (
    <div className="home">
      <Banner banners={banners}>
        <BannerForm
          name="免费获取定制版学情报告"
          title="给我一年时间，还您一个奇迹！"
          stitle="学大全日制复读班"
        />
      </Banner>
      <ul className={classnames("navbar")}>
        <li>
          <img src={require("@/assets/images/icon_fudusheng.png")} alt="" />
          <span>复读生</span>
        </li>
        <li>
          <img src={require("@/assets/images/icon_yikaosheng.png")} alt="" />
          <span>艺考生</span>
        </li>
        <li>
          <img src={require("@/assets/images/icon_yingjiesheng.png")} alt="" />
          <span>应届生</span>
        </li>
        <li>
          <img src={require("@/assets/images/icon_huiliusheng.png")} alt="" />
          <span>大学回流生</span>
        </li>
      </ul>
      <section className={classnames("universityReason-container")}>
        <h3 className="section__title">为什么要上好大学？</h3>
        <div className="section__inner">
          <div className={classnames("reason-th-wrap")}>
            <ul>
              <li>名牌大学</li>
              <li></li>
              <li>普通大学</li>
            </ul>
          </div>
          <div className={classnames("reason-table-wrap")}>
            <img
              src={require("@/assets/images/university-reason.png")}
              alt=""
            />
          </div>
        </div>
        <h4
          className={classnames("reason-receive")}
          onClick={() => {
            window.openJesongChatByGroup(121, 52601)
            return false
          }}
        >
          如何圆梦里想大学？立即点击咨询
        </h4>
      </section>
      <Feature></Feature>
      <section className={classnames("teachers-container")}>
        <h3 className="section__title">学大全日制实力师资团队</h3>
        <div className="section__inner">
          <div className={classnames("teachers-wrap")}>
            <div className={classnames("teachers-left")}></div>
            <ul className={classnames("teachers-content")}>
              {teacers.map((m) => (
                <li key={m.name}>
                  <h5>{m.name}</h5>
                  <p>{m.intro}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <Environment photos={photos} />
      <Campus />
    </div>
  )
}

function Feature() {
  const classnames = classModuleGenerator(styles)
  return (
    <section className={classnames("feature-container")}>
      <h3 className="section__title">学大全日制办学特色</h3>
      <div className="section__inner">
        <div className={classnames("module1")}>
          <ul>
            <li>
              <h5>统一管理</h5>
              <p>封闭式管理模式，专业化管理团队</p>
            </li>
            <li>
              <h5>双严标准</h5>
              <p>教师选拔严要求，教学质量严把控</p>
            </li>
            <li>
              <h5>三清教学</h5>
              <p>日日清，周周清，月月清</p>
            </li>
            <li>
              <h5>四维服务</h5>
              <p>课程规划，心理疏导，家庭教育，志愿填报</p>
            </li>
            <li>
              <h5>五大师训</h5>
              <p>金牌教师，贴身班主任，德育管理师，心里辅导师，医疗保障师</p>
            </li>
          </ul>
        </div>
        <div className={classnames("module2")}>
          <ul>
            <li>
              <h5>六科提升</h5>
              <p>各科模块化学习，双向细目表对比</p>
            </li>
            <li>
              <h5>七无校园</h5>
              <p>无烟，无网络，无手机，无干扰，无隐患，无顾虑，无霸凌</p>
            </li>
            <li>
              <h5>八大定位</h5>
              <p>八次定位考科学通关，多轮复习，分层滚动教学</p>
            </li>
            <li>
              <h5>九方安心</h5>
              <p>
                合规资质，舒适环境，星级宿舍，营养膳食，卫生达标 <br />
                独立操场，标准实验室，新风全覆盖，监控无死角
              </p>
            </li>
            <li>
              <h5>零距离家校</h5>
              <p>家长实时掌握学生每一次进步与成长</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}
export { Feature, Index }
export default Index
